export default __webpack_public_path__ + "static/media/sponsor-seldon.5b4c7146.svg";